import { Link } from "react-router-dom";
import { Phone, Sparkles } from "lucide-react";
import { priceLabel } from "@/lib/api";
import { BrandLogo } from "@/components/BrandLogo";
import { PoweredBy } from "@/components/VinconexMark";

export function daysAgo(iso) {
  if (!iso) return null;
  const d = Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
  return d <= 0 ? "Arrived today" : d === 1 ? "Arrived yesterday" : `Arrived ${d} days ago`;
}

export function PublicVehicleCard({ v, showAdded = false }) {
  return (
    <Link
      to={`/v/${v.id}`}
      data-testid={`public-vehicle-${v.id}`}
      className="group rounded-xl overflow-hidden border border-[#2A2E3D] bg-[#12141C] hover:border-brand hover:shadow-[0_0_20px_rgb(var(--brand-rgb)/0.25)] transition-all"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-black">
        {v.image && (
          <img src={v.image} alt={v.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
        )}
        {showAdded && (
          <span className="absolute top-2 left-2 text-[10px] font-mono-tech uppercase tracking-widest bg-brand text-white px-2 py-1 rounded-full flex items-center gap-1">
            <Sparkles className="h-3 w-3" /> {daysAgo(v.arrived_at || v.created_at)}
          </span>
        )}
        <span className="absolute top-2 right-2 text-[10px] font-semibold bg-black/70 backdrop-blur px-2 py-1 rounded-full">{v.condition}</span>
      </div>
      <div className="p-4">
        <div className="text-sm font-semibold truncate">{v.year} {v.make} {v.model}</div>
        <div className="text-xs text-slate-500 truncate">{v.trim}</div>
        <div className="mt-2 flex items-center justify-between">
          <span className="text-brand font-bold">{priceLabel(v.price)}</span>
          {v.mileage != null && <span className="text-xs text-slate-500">{v.mileage.toLocaleString()} mi</span>}
        </div>
      </div>
    </Link>
  );
}

export function DealerNav({ dealer }) {
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-black/70 border-b border-[#2A2E3D]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to={`/d/${dealer.slug}`} data-testid="dealer-home-link">
          <BrandLogo dealer={dealer} />
        </Link>
        {dealer.phone && (
          <a href={`tel:${dealer.phone}`} data-testid="dealer-phone-link" className="flex items-center gap-2 text-sm text-slate-300 hover:text-white">
            <Phone className="h-4 w-4 text-brand" />
            <span className="hidden sm:inline">{dealer.phone}</span>
          </a>
        )}
      </div>
    </header>
  );
}

export function DealerFooter({ dealer }) {
  return (
    <footer className="border-t border-[#2A2E3D] py-8 mt-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="text-xs text-slate-500">
          <span className="text-slate-300 font-semibold">{dealer.name}</span>
          {dealer.address && <span> · {dealer.address}</span>}
        </div>
        <PoweredBy />
      </div>
    </footer>
  );
}
